import React from "react";
import { FaFacebook, FaTwitter, FaLinkedin, FaPhoneAlt, FaInstagram } from "react-icons/fa";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import { CiLocationOn } from "react-icons/ci";
import { BiInfoCircle } from "react-icons/bi";
import { SendFill } from "react-bootstrap-icons";

export default function Footer() {
  return (
    <motion.footer
      className="bg-primary text-white pt-5"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="container">
        <div className="row mb-4">
          <div className="col-md-6 col-lg-3 mb-4">
            <img src="/images/logo-white.svg" alt="" />
            <div className="d-flex gap-3 mt-3">
              <FaFacebook className="fs-2 hover-text cursor-pointer" />
              <FaTwitter className="fs-2 hover-text cursor-pointer" />
              <FaLinkedin className="fs-2 hover-text cursor-pointer" />
              <FaInstagram className="fs-2 hover-text cursor-pointer" />
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex align-items-start gap-2">
                <CiLocationOn className="fs-1" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=256,+1st+AVE,+Manchester+125,+North+England"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover-text text-decoration-none"
                >
                  256, 1st AVE, Manchester 125, North England
                </a>
              </div>
              <div className="d-flex align-items-center gap-2">
                <FaPhoneAlt className="fs-5" />
                <div>
                  <a
                    href="https://wa.me/012345678102"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-block text-white hover-text text-decoration-none"
                  >
                    +012 345 678 102
                  </a>
                  <a
                    href="https://wa.me/012345678101"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-block text-white hover-text text-decoration-none"
                  >
                    +012 345 678 101
                  </a>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2">
                <BiInfoCircle className="fs-3" />
                <a
                  href="mailto:info@bedspace.site"
                  className="text-white hover-text text-decoration-none"
                >
                  info@bedspace.site
                </a>
              </div>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <h3 className="text-xl font-bold mb-4">Useful Links</h3>
            <ul className="list-unstyled">
              <li className="pb-1 hover-text text-capitalize animated-footer cursor-pointer">
                Rental Buildings
              </li>
              <li className="pb-1 hover-text text-capitalize animated-footer cursor-pointer">
                Browse all Categories
              </li>
              <li className="pb-1 hover-text text-capitalize animated-footer cursor-pointer">
                Top Mortgages Rates
              </li>
              <li className="pb-1 hover-text text-capitalize animated-footer cursor-pointer">
                Terms of use
              </li>
              <li className="pb-1 hover-text text-capitalize animated-footer cursor-pointer">
                Privacy Policy
              </li>
            </ul>
          </div>

          <div className="col-md-6 col-lg-3 mb-4">
            <h3 className="text-xl font-bold mb-4">Newsletter</h3>
            <p className=" mb-4">
              Subscribe to our newsletter and get the latest news about properties, promotions,
              offers, and discounts.
            </p>
            <div className="d-flex rounded-3">
              <input
                type="email"
                placeholder="Email Here.."
                className="form-control border-0 rounded-end-0 py-2 px-4 ps-2"
              />
              <button className="btn btn-warning rounded-start-0 px-4 py-2">
                <SendFill className="text-white" />
              </button>
            </div>
          </div>
        </div>

        <div className="border-top pt-3 pb-1 text-center">
          <p>
            Copyright ©{new Date().getFullYear()}{" "}
            <span className="fw-bold text-warning">Bed Space</span> All rights reserved.
          </p>
        </div>
      </div>
    </motion.footer>
  );
}
